import {
   
    GET_COMMONCATEGORY_STARTED,
   
    GET_COMMONCATEGORY_COMPLETED,
    GET_COMMONCATEGORY_FAILED,

} from '../actions/Commoncategory';

const intialCOMMONCATEGORYData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const COMMONCATEGORYData = (state = intialCOMMONCATEGORYData, action: any) => {
    
 
    switch (action.type) {
        case GET_COMMONCATEGORY_STARTED: 
       // alert("start");         
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case GET_COMMONCATEGORY_COMPLETED:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case GET_COMMONCATEGORY_FAILED:
      return {
        ...state,
        isLoading: true,
      };
     

        default:
            return state;
    }
};